import { Dialog, InputLabel, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DivBackdrop = styled('div')({
  outline: 'none',
});

export const DialogFieldStyled = styled(Dialog)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  '& form': {
    maxHeight: '90vh',
    overflow: 'auto',
  },
  '& .MuiDialog-scrollPaper': {
    width: '100%',
  },
  '& .react-draggable': {
    backgroundColor: 'white',
    border: 0,
    maxWidth: 640,
    outline: 'none',
    padding: '20px',
    width: '100%',
  },
});

export const DivDialogTitle = styled('div')({
  textAlign: 'center',
});

export const InputLabelDataType = styled(InputLabel)({
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontSize: '13px',
  fontWeight: 400,
  justifyContent: 'center',
  letterSpacing: '0.00938em',
  lineHeight: 'normal',
  position: 'relative',
  top: '5px',
  transform: 'none',
});

export const DivExtraMargin = styled('div')({
  marginTop: '14px',
});

export const DivFlexChild = styled('div')({
  width: '48%',
});

export const DivFlexContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export const DivFlexEnd = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const SelectFormControl = styled(Select)(() => ({
  margin: '8px 0',
  minWidth: 120,
  '& .MuiInputLabel-root': {
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    justifyContent: 'center',
    letterSpacing: '0.00938em',
    lineHeight: 'normal',
    position: 'relative',
    top: '5px',
    transform: 'none',
  },
}));

export const DivInputButtonsWrapper = styled('div')({
  bottom: 0,
  position: 'absolute',
  right: 0,
});

export const DivInputIcon = styled('div')({
  height: '25px',
});

export const InputLabelStyled = styled(InputLabel)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  verticalAlign: 'middle',
  '& .inputLabelIcon': {
    cursor: 'pointer',
    fontSize: '20px',
    marginLeft: '10px',
    opacity: 0,
    transition: 'opacity .35s',
  },
  '&:hover .inputLabelIcon': {
    opacity: 1,
  },
});

export const DivInputLabelStyled = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  verticalAlign: 'middle',
  // border: '1px solid red',
  // padding: '0px 0 4px',
  margin: '-8px 0px 0px',
  '& .inputLabelIcon': {
    cursor: 'pointer',
    fontSize: '20px',
    marginLeft: '10px',
    opacity: 0,
    transition: 'opacity .35s',
  },
  '&:hover .inputLabelIcon': {
    opacity: 1,
  },
});

export const DivInputWrapper = styled('div')({
  display: 'flex',
  position: 'relative',
});

export const SpanInputLabelError = styled('span')({
  color: '#f44336',
});

export const DivInputLabelRoot = styled('div')({
  // label: {
  marginTop: '-10px',
  // padding: '10px 7px 5px 0',
  width: '100%',
  // border: '1px solid blue',
  // top: '-11px',
  label: {
    span: {
      fontSize: '1.4rem',
    },
  },
  // },
});

// export const DivInputWrapper = styled('div')({
//   display: 'flex',
//   position: 'relative',
// });
